import React from 'react';
import { CalendarRange } from 'lucide-react';
import type { DateRangePreset } from '../lib/dateFilter';

interface Props {
  preset: DateRangePreset;
  start: string;
  end: string;
  label: string;
  onPreset: (p: DateRangePreset) => void;
  onStart: (v: string) => void;
  onEnd: (v: string) => void;
}

const PRESETS: { id: DateRangePreset; label: string }[] = [
  { id: 'all', label: 'All time' },
  { id: 'today', label: 'Today' },
  { id: 'this_week', label: 'This week' },
  { id: 'this_month', label: 'This month' },
  { id: 'last_month', label: 'Last month' },
  { id: 'this_quarter', label: 'This quarter' },
  { id: 'this_year', label: 'This year' },
  { id: 'custom', label: 'Custom' },
];

export function SuperAdminDateBar({ preset, start, end, label, onPreset, onStart, onEnd }: Props) {
  return (
    <div className="rounded-xl border border-zinc-200 bg-white p-3 shadow-sm sm:p-4">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-2 text-sm text-zinc-700">
          <CalendarRange className="h-4 w-4 text-emerald-600" />
          <span className="font-medium">Reporting period:</span>
          <span className="font-semibold text-zinc-900">{label}</span>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <select
            value={preset}
            onChange={(e) => onPreset(e.target.value as DateRangePreset)}
            className="h-9 min-w-0 flex-1 rounded-lg border border-zinc-200 bg-zinc-50 px-2 text-sm font-medium text-zinc-800 focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/15 sm:flex-none"
          >
            {PRESETS.map((p) => (
              <option key={p.id} value={p.id}>
                {p.label}
              </option>
            ))}
          </select>
          <div className="flex w-full min-w-0 flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
            <input
              type="date"
              value={start}
              onChange={(e) => onStart(e.target.value)}
              className="h-9 w-full min-w-0 max-w-full rounded-lg border border-zinc-200 bg-zinc-50 px-2 text-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/15 sm:w-auto sm:max-w-[11rem]"
            />
            <span className="hidden text-xs text-zinc-400 sm:inline">to</span>
            <input
              type="date"
              value={end}
              onChange={(e) => onEnd(e.target.value)}
              className="h-9 w-full min-w-0 max-w-full rounded-lg border border-zinc-200 bg-zinc-50 px-2 text-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/15 sm:w-auto sm:max-w-[11rem]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
